export type ButtonVariant = 'gold' | 'navy' | 'outlineLight' | 'outlineDark';

const buttonBase =
  'inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-sm px-6 text-[15px] font-medium transition-[background-color,border-color,color,transform] duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.98] active:duration-100 disabled:cursor-not-allowed disabled:opacity-60';

const buttonVariants: Record<ButtonVariant, string> = {
  gold: 'bg-gold text-navy hover:bg-gold-light',
  navy: 'bg-navy text-white hover:bg-navy-700',
  outlineLight: 'border border-white/30 text-white hover:border-gold hover:text-gold',
  outlineDark: 'border border-navy/25 text-navy hover:border-navy',
};

export function buttonClass(variant: ButtonVariant, extra = ''): string {
  return `${buttonBase} ${buttonVariants[variant]} ${extra}`.trim();
}

export function inputClass(hasError: boolean): string {
  return [
    'block w-full rounded-sm border bg-white px-3.5 py-3 text-[15px] text-ink placeholder:text-muted/60',
    'transition-[border-color,box-shadow] duration-150 ease-out focus:outline-none focus:ring-2',
    hasError
      ? 'border-danger focus:border-danger focus:ring-danger/15'
      : 'border-line hover:border-navy/30 focus:border-navy focus:ring-navy/10',
  ].join(' ');
}

export function describedBy(id: string, hasHint: boolean, hasError: boolean): string | undefined {
  const ids: string[] = [];
  if (hasHint) ids.push(`${id}-hint`);
  if (hasError) ids.push(`${id}-error`);
  return ids.length > 0 ? ids.join(' ') : undefined;
}
